import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setLoader } from "./MasterSlice";
import * as API from "../../utils/api.service";
import { TOAST_SUCCESS } from "../../utils/common.service";
import { data } from "jquery";

export const getClientListApiCall = createAsyncThunk("clientList", async (submitData, { dispatch }) => {
    try {
        dispatch(setLoader(true))
        const { data: clientList } = await API.getUserListApi(submitData);

        //console.log("================================================",clientList);
        

        dispatch(setLoader(false))
        return {"count":clientList?.user_count,"user":clientList?.users};
    } catch (error) {
        throw error;
    }
});

export const editClientDataApiCall = createAsyncThunk("editClientData", async (submitData, { dispatch }) => {
    try {
        dispatch(setLoader(true))
        const { data: editClientData, code, message } = await API.editClientDetailsApi(submitData);
        if (code === '1') {
            //TOAST_SUCCESS(message);
        }
        dispatch(setLoader(false))
        return { data: editClientData, code, message };
    } catch (error) {
        throw error;
    }
});

const initialState = {
    clientList: {
        data: [],
        error: null,
    },
    editClientData: {
        data: null,
        code: '',
        message: '',
        error: null,
    },
};

const clientSlice = createSlice({
    name: "CLIENT",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getClientListApiCall.fulfilled, (state, action) => {
                state.clientList.data = action.payload;
            })
            .addCase(getClientListApiCall.rejected, (state, action) => {
                state.clientList.error = action.error.message;
            })
            .addCase(editClientDataApiCall.fulfilled, (state, action) => {
                const { message, code, data } = action.payload;
                state.editClientData.data = data;
                state.editClientData.message = message;
                state.editClientData.code = code;
            })
            .addCase(editClientDataApiCall.rejected, (state, action) => {
                state.editClientData.error = action.error.message;
            });
    },
});

export default clientSlice.reducer;